import axios from '@/plugins/axios';
import { snackBarError, snackBarSuccess } from '@/utils/snackbar';

export default {
	async sendnotificationPush({ commit }, { personId, lodgingId, subtitle, type, handler }) {
		try {
			const { data } = await axios(`/user/${personId}/notification-push`, {
				method: 'post',
				data: { lodgingId, subtitle, type, handler },
			});
			snackBarSuccess(data.message)(commit);
			return data;
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async removeShareWithMeUser({ commit, dispatch }, payload) {
		try {
			await axios(`/user/actions/share/remove-with-me`, {
				method: 'delete',
				data: { email: payload.userEmail },
			});
			snackBarSuccess('Usuario removido con exito')(commit);
			dispatch('fetchProfile');
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async fetchUsers({ commit }) {
		try {
			const { data } = await axios('/users');
			const { users } = data;
			commit('setUsers', users);
			return users;
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async patchInvoice({ commit, dispatch }, payload) {
		try {
			const { data } = await axios(`/user/invoice/send-pay`, {
				method: 'patch',
				data: payload,
			});
			snackBarSuccess('Notificación recibida')(commit);
			dispatch('fetchInvoice');
			return data.invoice;
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async fetchInvoice({ commit }) {
		try {
			const { data } = await axios('/user/invoice');
			return data;
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async fetchInvoiceByIdUser({ commit }, idUser) {
		try {
			const { invoice } = await axios(`/user/invoice/${idUser}`);
			commit('setInvoiceByUser', invoice);
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async sharePlaceAndPersons({ commit, dispatch }, payload) {
		try {
			const { email } = payload;
			await axios(`/user/actions/share/place-and-person`, {
				method: 'patch',
				data: { email: email },
			});
			snackBarSuccess('Usuario invitado con exito')(commit);
			dispatch('fetchProfile');
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async removeShareWithUser({ commit, dispatch }, payload) {
		try {
			const { email } = payload;
			await axios(`/user/actions/share/remove`, {
				method: 'delete',
				data: { email: email },
			});
			snackBarSuccess('Usuario removido con exito')(commit);
			dispatch('fetchProfile');
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async fetchProfile({ commit }) {
		try {
			const { data } = await axios('/user/profile');
			const { profile } = data;
			commit('setProfile', profile);
			commit('setUserSharingEmails', profile.userSharingEmails);
			commit('setSharingWithMeEmails', profile.sharingWithMeEmails);
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async fetchProfileById({ commit }, id) {
		try {
			const { data } = await axios(`/user/profile/${id}`);
			commit('setUserProfile', data.profile);
			return data.profile;
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async fetchAdminProfile({ commit }, id) {
		try {
			const { data } = await axios(`/user/profile/${id}`);
			return data.profile.role;
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async updateProfile({ commit }, payload) {
		try {
			commit('setLoading', true);
			delete payload.analyst;
			delete payload._id;
			delete payload.email;
			delete payload.userSharingEmails;
			delete payload.notifications;
			delete payload.workOrdersName;
			delete payload.numberWorkOrders;
			const { data } = await axios('/user/profile', {
				method: 'put',
				data: payload,
			});
			snackBarSuccess('Actualizado con exito')(commit);
			commit('setProfile', data.profile);
		} catch (error) {
			snackBarError(error)(commit);
		} finally {
			commit('setLoading', false);
		}
	},
	async updateAvatar({ commit }, avatar) {
		try {
			const { data } = await axios('/user/avatar', {
				method: 'patch',
				data: avatar,
			});
			commit('setAvatar', data.img);
			snackBarSuccess('Avatar actualizado con exito')(commit);
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async updatePassword({ commit }, password) {
		try {
			await axios('/user/password', {
				method: 'patch',
				data: { password },
			});
			snackBarSuccess('Contraseña actualizada con exito')(commit);
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async passwordRecover({ commit }, data) {
		try {
			await axios('/auth/user/password-recover', {
				method: 'post',
				data,
			});
			snackBarSuccess('Solicitud enviada')(commit);
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async getPublicAssistance({ commit }, loginData) {
		try {
			const { data } = await axios(`user/public-assistance`, {
				method: 'post',
				data: loginData,
			});
			snackBarSuccess('Obtenida asistencia')(commit);
			return data;
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async updatePublicAssistance({ commit }, payload) {
		try {
			const { data } = await axios(`user/update-public-assistance`, {
				method: 'post',
				data: payload,
			});
			snackBarSuccess(data.message)(commit);
			commit('setProfile', data.user);
			return data;
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
};
